import React, { useEffect } from "react";
import { useRouteData } from "react-static";

import CollectableView from "@components/CollectableView";
import useBodyClass from "@utils/useBodyClass";
import Layout from "../components/Layout";

export default () => {
  const { item: collectable } = useRouteData();
  useBodyClass("collectable", "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout
      recordLocation
      // Key prevent react from trying to keep this components between navigations
      key={collectable.id}
    >
      <CollectableView collectable={collectable} />
    </Layout>
  );
};
